import { z } from 'zod';

export const contractingAuthoritySchema = z.object({
  nom: z.string().min(1, 'Le nom ne doit pas être vide').max(250, 'Le nom ne doit pas dépasser 250'),
  email: z.string({ message: "L'e-mail est obligatoire" }).trim().email({ message: 'Veuillez saisir une adresse e-mail valide' }).toLowerCase(),
  adresse: z
    .object({
      codePostal: z.string().regex(/^\d+$/, 'Code postal doit être numérique').optional().or(z.literal('')),
    })
    .optional(),
});
